import React from 'react'
import { useState,useEffect } from 'react'

import ApiUrl from '../../../../configTools/apiUrl';
import Searchbar from '../../../../components/forms/searchbar';
import Item from '../../orders/item';
const Orders = ({username}) => {
    const User = JSON.parse(localStorage.getItem("user-info"));
    const [Navigation,setNavigation] = useState([]);
    const [FilterNavigation,setFilterNavigation] = useState(Navigation);
    const get_admin_nav = () =>{
      fetch(ApiUrl.API_URL_OrdersUser+"/"+username,{
          headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer '+User.token
          }
      })
      .then(res=>res.json())
      .then(data =>{
          if(data.success){
              setNavigation(data.responce);
              setFilterNavigation(data.responce);
          }
      });
    }
    function filterFunction(value){
      if(value === ""){
        setFilterNavigation(Navigation);
      }
      else{
        const filtedNavigation = Navigation.filter((obj)=>{
          return Object.values(obj)
          .join(" ").toLowerCase()
          .includes(value.toLowerCase());
        })
        setFilterNavigation(filtedNavigation);
      }
    }
    useEffect(() => {
      get_admin_nav();
    },[User])
    return (
      <div className='form_container'>
        <div className='form_table_container'>
          <Searchbar Filter={filterFunction}/>
          <div className='form_item_row_container title'>
            <div className='form_item_row_container_itemfull' style={{width:'12%'}}>
              <p>Order#</p>
            </div>
            <div className='form_item_row_container_item' style={{width:'11%'}}>
              <p>Fulfilment Status</p>
            </div>
            <div className='form_item_row_container_item' style={{width:'11%'}}>
              <p>Payment</p>
            </div>
            <div className='form_item_row_container_item' style={{width:'11%'}}>
              <p>Net Total</p>
            </div>
            <div className='form_item_row_container_item' style={{width:'11%'}}>
              <p>Buyer Shipping</p>
            </div>
            <div className='form_item_row_container_item' style={{width:'11%'}}>
              <p>Grand Total</p>
            </div>
            <div className='form_item_row_container_item' style={{width:'11%'}}>
              <p>Kaay Commission</p>
            </div>
            <div className='form_item_row_container_item' style={{width:'11%'}}>
              <p>Seller Shipping</p>
            </div>
            <div className='form_item_row_container_item' style={{width:'11%'}}>
              <p>Seller Payables</p>
            </div>
          </div>
          {
            FilterNavigation.map((item)=>{
              return(
                <Item Obj = {item} key={item.id} />
              );
            })
          }
        </div>
      </div>
    )
}

export default Orders
